/* RESPONSIBLE TEAM: team-ai-agent */
import { type TypeaheadConfig } from '@intercom/composer-ember';
import { triggerCharacter } from '@intercom/composer-ember/lib/composer/typeahead/trigger-character';

const contentTypeaheadConfig: TypeaheadConfig = {
  name: 'content',
  matcher: triggerCharacter('@', { allowSpaces: true }),
  component: 'ai-agent/guidance/content-typeahead',
};

export default contentTypeaheadConfig;
